import { HubConnectionBuilder } from '@microsoft/signalr';

let connection = null;

export const connectToStockHub = async (username, sessionId, URL) => {
    try {
        connection = new HubConnectionBuilder()
            .withUrl(`${URL}?username=${username}&sessionId=${sessionId}`)
            .withAutomaticReconnect()
            .build();

        await connection.start();
        console.log("✅ Conectado al Hub");

        // Registrar usuario en el servidor
        await connection.invoke("RegisterUser", sessionId);
        console.log(`📝 Usuario registrado correctamente: ${sessionId}`);

        // Escuchar confirmación de registro
        connection.on("registered", (message) => {
            console.log("🔗 Registro confirmado:", message);
        });

    } catch (err) {
        console.error("❌ Error al conectar al Hub:", err);
    }
};

export const openSock = (eventName, onMessageReceived) => {
    if (!connection) {
        console.warn("⚠️ No hay conexión activa. Llama a connectToStockHub primero.");
        return;
    }

    try {
        connection.off(eventName); // Limpia cualquier suscripción previa
        connection.on(eventName, onMessageReceived);

    } catch (err) {
        console.error("❌ Error al conectar al evento:", err);
    }
};

export const disconnectStockHub = async () => {
    try {
        if (connection) {
            await connection.stop();
            console.log("🔌 Desconectado del Hub");
        }
    } catch (err) {
        console.error("❌ Error al desconectar del Hub:", err);
    } finally {
        connection = null;
    }
};
